import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FolderItemType } from '../models/FolderItemType';

@Injectable({
  providedIn: 'root',
})
export class OneApiService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {}

  itemsInRootFolder(
    accountId: string,
    itemType: FolderItemType,
    items: string[],
  ) {
    return this.httpClient.put(`${this.apiBaseUrl}tools/items-in-root-folder`, {
      accountId,
      itemType,
      items,
    });
  }
}
